@if (!isAuthenticated) {
  <div class="flex lg:flex-row flex-col text-center">
    <span>Have account credit or digital wallet?</span>
    <a (click)="signInRedirect()" class="ml-5"
      >Login to your {{ configurationService.configuration.clientName }} account
      to use it.</a
    >
  </div>
} @else {
  <div class="flex lg:flex-row flex-col justify-center items-center gap-4">
    <span>Welcome {{ patronName }}</span>
    <sdc-button
      className="!w-28 min-w-max h-10"
      theme="theme-sdc"
      variant="primary"
      (onClick)="signOut()">
      Sign out
    </sdc-button>
  </div>
}
